"use client";

import { Tooltip as BaseTooltip } from "@base-ui/react/tooltip";
import type { ReactElement, ReactNode } from "react";
import { cn } from "@/lib/utils";

interface TooltipProps {
  className?: string;
  label: ReactNode;
  popupClassName?: string;
  render: ReactElement;
  sideOffset?: number;
}

export const TooltipProvider = BaseTooltip.Provider;

export function Tooltip({
  className,
  label,
  popupClassName,
  render,
  sideOffset = 8,
}: TooltipProps) {
  return (
    <BaseTooltip.Root>
      <BaseTooltip.Trigger className={className} render={render} />
      <BaseTooltip.Portal>
        <BaseTooltip.Positioner sideOffset={sideOffset}>
          <BaseTooltip.Popup className={cn("tooltip-popup", popupClassName)}>
            {label}
          </BaseTooltip.Popup>
        </BaseTooltip.Positioner>
      </BaseTooltip.Portal>
    </BaseTooltip.Root>
  );
}
